import { Button } from '@ondit/ui'
import { useAccount } from '~/common/account/account'
import { ApiError } from '~/core/api/transport'
import { useI18n, useT } from '~/core/i18n'
import { Async } from '~/core/ui/states'
import { WorkspaceAccessDenied } from './workspace-access-denied'

export function workspaceFailure(error: unknown): 'subscription' | 'access' | 'load' {
  if (!(error instanceof ApiError)) return 'load'
  if (error.gate === 'subscription_required' || error.gate === 'subscription_expired')
    return 'subscription'
  return (error.status === 403 && error.code !== 'gated') || error.status === 404
    ? 'access'
    : 'load'
}

export function WorkspaceLoadError({ error, retry }: { error: unknown; retry: () => unknown }) {
  const t = useT()
  const { locale } = useI18n()
  const openAccount = useAccount()
  const kind = workspaceFailure(error)
  if (kind === 'access') return <WorkspaceAccessDenied />
  if (kind === 'subscription')
    return (
      <div className='empty' role='alert'>
        <p>{t('billing.runRequiresPlan')}</p>
        <Button onClick={() => openAccount('subscription')}>{t('billing.subscribeAction')}</Button>
      </div>
    )
  if (error instanceof ApiError && error.isUnauthorized) {
    return (
      <Async state={{ data: undefined, error, isFetching: false, refetch: retry }}>
        {() => null}
      </Async>
    )
  }
  return (
    <div className='empty' role='alert'>
      <h2>{t('state.error')}</h2>
      {error instanceof ApiError && <p>{error.localized(locale)}</p>}
      <Button onClick={() => void retry()}>{t('state.retry')}</Button>
    </div>
  )
}
